module.exports = (modules)->
  {React,Icon,textedit_utils,CollapsePanel,reducers,SharedReducers,slate} = modules
     
  # what name to use, should be unique
  name:"TrainingComplete"

  tags:{"trainingcomplete"}

  # html to insert from drag and drop
  drophtml:'<training-complete></training-complete>'
  
  # What to render in the toolbar when element is selected
  # toolbar:TrainingProgessToolbar(modules)
  
  # what icon to show in media elements
  icon:(props)-> 
    <React.Fragment>
      <div style={{border:"1px solid rgba(255.255.255.0.1)",width:48,height:35,margin:"0 auto",position:"relative"}}>
        <svg version="1.1" viewBox="-25 0 150 100" xmlns="http://www.w3.org/2000/svg">
           <g fill="currentColor">
            <path d="m87.5 81.25c0 3.3867-2.8633 6.25-6.25 6.25h-62.5c-3.3867 0-6.25-2.8633-6.25-6.25v-62.5c0-3.3867 2.8633-6.25 6.25-6.25h50l12.5-12.5h-62.5c-10.312 0-18.75 8.4375-18.75 18.75v62.5c0 10.312 8.4375 18.75 18.75 18.75h62.5c10.312 0 18.75-8.4375 18.75-18.75v-37.5l-12.5 12.5z"/>
            <path d="m43.75 56.156l-15.574-15.582-12.602 12.602 28.176 28.176 56.301-56.301-12.602-12.602z"/>
          </g>
        </svg>
      </div>
      <span className="label">Training Complete</span>
    </React.Fragment>

  plugins:[{ 
    schema:
      blocks:
        trainingcomplete:
          isVoid: true
  }]
  
  # convert AST to HTML
  serialize:(object, children)->
    if object.type == "trainingcomplete"
      return <training-complete path={object.data.get("path")}></training-complete>

  # convert HTML to AST
  deserialize:(el,next)->
    return if el.tagName?.toLowerCase()!="training-complete"
    attributes = textedit_utils.attributesFromElement(el)
    {
      object: 'block',
      type: "trainingcomplete",
      isVoid: true,
      data: attributes
    }
  
  # convert AST to inpage editing component
  renderNode:({attributes, children, node, isSelected, editor} )->
    return if node.type!="trainingcomplete"
    attributes.style = {} if !attributes.style
    # attributes = Object.assign({},attributes,{className:node.data.toObject().className})
    props = node.data.toObject()
    <training-complete attributes={attributes}></training-complete>